import { cn } from '@/utils';
import Tile from '../../molecules/Tile';

const TileList = ({
  className,
  tileClassName,
  headline,
  items,
  onItemClick,
  parentId,
  loadingIndex,
  LoadingIcon,
  showIcon,
  isDisabled,
  Icon,
  showLabel,
  linkText,
  onLinkClick,
  id,
  getItemDataAttributes = () => ({}),
}) => {
  const handleLinkClick = () => {
    onLinkClick();
  };

  return (
    <div id={id} className="mb-2xl">
      <div className="flex justify-between items-center mb-2xs">
        <label className="block font-semibold text-sm desktop:text-base">
          {headline}
        </label>
        <If condition={linkText}>
          <button
            className="bg-transparent border-none text-[color:var(--theme-link-text-color-2)] font-bold inline-flex items-center whitespace-nowrap gap-4xs"
            onClick={handleLinkClick}
          >
            <ft-icon name="info" width={20} height={20}></ft-icon>
            <span className="text-xs desktop:text-sm">{linkText}</span>
          </button>
        </If>
      </div>
      <div className="flex flex-wrap -m-3xs">
        {items.map((item, i) => {
          const { label, is_selected, id, orgIndex } = item;
          const dataAttributes = getItemDataAttributes(item);
          return (
            <Tile
              key={i}
              index={i}
              orgIndex={orgIndex}
              id={id}
              parentId={parentId}
              isSelected={is_selected}
              className={tileClassName}
              onClick={onItemClick}
              LoadingIcon={LoadingIcon}
              loadingIndex={loadingIndex}
              {...{ isDisabled, dataAttributes }}
            >
              <Choose>
                <When condition={showIcon && Icon}>
                  <Icon id={id} label={label} showLabel={showLabel}/>
                </When>
                <Otherwise>{label}</Otherwise>
              </Choose>
            </Tile>
          );
        })}
      </div>
    </div>
  );
};

export default TileList;
